const drillEvents = (events, name) =>
  events
    .filter((e) => e.eventName === name)
    .reduce((p, e) => p + parseInt(e.eventCount), 0);

export default drillEvents;
